export default __webpack_public_path__ + "static/media/twddc002.91550f16.jpg";